import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { CartScopeEq } from '@/models/cart/group/scope'
import { NoveltyService } from '@/services/novelty'
import AppId from '@/util/appid'
import { ListCouponForOrder } from '@spa/components/pages/order/model/order/list-coupon-for-order'
import CouponService from '@spa/services/api/coupon'
import { PurchaseService } from '@spa/services/api/purchase'
import { OrderService, OrderSource } from '@spa/services/order'

export interface OrderServiceLocator {
  behavior: BehaviorConfig
  purchaseService: PurchaseService
  orderService: OrderService
  noveltyService: NoveltyService
  listCoupon: ListCouponForOrder
}

const buildListCoupon = (scope: CartScopeEq) =>
  () => CouponService.createWithScope(scope).list({ only_usable: true })

const createForBrand = (brandName: string, scope: CartScopeEq): OrderServiceLocator => {
  const appId = AppId.getByBrandName(brandName)
  const behavior = BehaviorConfig.createFromBrand(brandName)

  return {
    behavior,
    purchaseService: new PurchaseService(appId),
    orderService: OrderService.create({
      appId,
      orderSource: OrderSource.asUndefined(),
    }),
    noveltyService: new NoveltyService(appId, behavior),
    listCoupon: buildListCoupon(scope),
  }
}
const createForHost = (scope: CartScopeEq) => {
  const appId = AppId.getHostId()
  const behavior = new BehaviorConfig(appId)

  return {
    behavior,
    purchaseService: new PurchaseService(appId),
    orderService: OrderService.create({
      appId,
      orderSource: OrderSource.asUndefined(),
    }),
    noveltyService: new NoveltyService(appId, behavior),
    listCoupon: buildListCoupon(scope),
  }
}

/**
 * ブランドスコープ以外では、一律ホストAppIdを利用する
 * @see https://github.com/my-color/front/issues/3934#issuecomment-644511220
 */
export const selectLocatorByScope = (scope: CartScopeEq): OrderServiceLocator => {
  if (scope.kind.isBrand) {
    /**
     * scopeだけを渡すようにしても良いが
     * - createForBrandから見て、「このスコープは確実にブランドスコープなのか？」が暗黙的になる
     * - 将来的に、SPAのパスが /:brand/order のようになり、スコープ以外からより確実にブランド名を取得できるかも
     * 等の理由で、スコープとブランド名は分離して渡す状態を維持している。
     */
    return createForBrand(scope.value.toString(), scope)
  }

  return createForHost(scope)
}
